'use client';

import { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Icon from '@/components/ui/AppIcon';


interface HeaderProps {
  className?: string;
}

const Header = ({ className = '' }: HeaderProps) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);

  const primaryNavItems = [
    { label: 'Home', href: '/homepage' },
    { label: 'Products', href: '/products' },
    { label: 'Resources', href: '/resources' },
    { label: 'About', href: '/about' },
    { label: 'Contact', href: '/contact' },
  ];

  const secondaryNavItems: { label: string; href: string; }[] = [];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setIsMoreMenuOpen(false);
  };

  const toggleMoreMenu = () => {
    setIsMoreMenuOpen(!isMoreMenuOpen);
  };

  return (
    <header className={`bg-background border-b border-border sticky top-0 z-50 ${className}`}>
      <div className="w-full">
        <div className="flex items-center justify-between h-16 px-4 lg:px-8">
          <Link href="/homepage" className="flex items-center space-x-3 flex-shrink-0">
            <Image
              src="/assets/images/Logo-1765819925031.png"
              alt="AIVA Medical Supply Logo"
              width={180}
              height={50}
              className="h-12 w-auto object-contain transition-transform duration-300 hover:scale-105"
              priority
            />
          </Link>

          <nav className="hidden lg:flex items-center space-x-1 flex-1 justify-center">
            {primaryNavItems.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                className="px-4 py-2 text-sm font-medium text-text-primary hover:text-primary hover:bg-muted rounded-md transition-all duration-250"
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-2 flex-shrink-0">
            <Icon name="EnvelopeIcon" size={20} className="text-primary" />
            <a 
              href="mailto:aivazian@aivamedicalssupply.com" 
              className="text-sm font-medium text-text-primary hover:text-primary transition-colors duration-250"
            >
              aivazian@aivamedicalssupply.com
            </a>
          </div>

          <button
            onClick={toggleMobileMenu}
            className="lg:hidden p-2 text-text-primary hover:text-primary hover:bg-muted rounded-md transition-colors duration-250"
            aria-label="Toggle mobile menu"
          >
            <Icon name={isMobileMenuOpen ? 'XMarkIcon' : 'Bars3Icon'} size={24} />
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden border-t border-border bg-background animate-slide-in-from-top">
            <nav className="px-4 py-4 space-y-1">
              {primaryNavItems.map((item) => (
                <Link
                  key={item.href}
                  href={item.href}
                  className="block px-4 py-3 text-base font-medium text-text-primary hover:text-primary hover:bg-muted rounded-md transition-all duration-250"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
              <div className="flex items-center gap-2 px-4 py-3">
                <Icon name="EnvelopeIcon" size={20} className="text-primary" />
                <a 
                  href="mailto:aivazian@aivamedicalssupply.com" 
                  className="text-sm font-medium text-text-primary hover:text-primary transition-colors duration-250"
                >
                  aivazian@aivamedicalssupply.com
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;